import { render, staticRenderFns } from "./stage.vue?vue&type=template&id=93e5d83e&"
import script from "./stage.vue?vue&type=script&lang=js&"
export * from "./stage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "stage.vue"
export default component.exports